// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"623":"3ad63c66","645":"064d94d1","850":"46c3ca06"}[chunkId] + ".chunk.css";
};